// deviceProductionAdapter — single isolation point for the per-device production
// detail endpoint (story 35-monitoring-screen-redesign).
//
// Sun contract: GET monitoring/deviceProduction/{deviceId}
//   auth: Apikey <token>, authority MONITORING || MOS.
// Every consumer of the production detail goes through `fetchDeviceProduction`, so if
// sun's shape changes only this file moves — no component is touched.
//
// Sun OMITS `order` when the device has no active fabrication order and OMITS `work`
// when there is no operation (CellWork) in progress. Following the repo convention of
// no null/undefined in business logic, both are normalized to `{}` here; callers test
// presence with `Object.keys(order).length > 0` / `Object.keys(work).length > 0`.
//
// On any failure (network error, or the endpoint not existing yet) it returns a
// degraded result instead of throwing, so callers never need their own try/catch.
import { apiGet } from '../generic/Api_Functions'

const DEVICE_PRODUCTION_ENDPOINT = 'monitoring/deviceProduction'

const EMPTY_DEVICE_PRODUCTION = {
  deviceId: 0,
  order: {},
  work: {},
  moves: [],
  degraded: false
}

/**
 * @param {number|string} deviceId
 * @returns {Promise<{deviceId: number|string, order: object, work: object, moves: object[], degraded: boolean}>}
 *   `order`/`work` are `{}` when sun omits them (no active OF / no operation in progress);
 *   `moves` is the live logistics movements involving the device (0..n).
 */
async function fetchDeviceProduction (deviceId) {
  try {
    const response = await apiGet(DEVICE_PRODUCTION_ENDPOINT + '/' + deviceId)
    return {
      deviceId: response?.deviceId ?? deviceId,
      order: response?.order ?? {},
      work: response?.work ?? {},
      moves: Array.isArray(response?.moves) ? response.moves : [],
      degraded: false
    }
  } catch (error) {
    return { ...EMPTY_DEVICE_PRODUCTION, deviceId, degraded: true }
  }
}

export { DEVICE_PRODUCTION_ENDPOINT, EMPTY_DEVICE_PRODUCTION, fetchDeviceProduction }
